import dataLayer from '../core/dataLayer'

export default {

    windowRequestAnimationFrame () {
        // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
        // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

        // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

        // MIT license

        (function () {
            let lastTime = 0
            const vendors = ['ms', 'moz', 'webkit', 'o']
            for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
                window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
                window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame']
            }

            if (!window.requestAnimationFrame) {
                window.requestAnimationFrame = (raf, element) => {
                    const currTime = new Date().getTime()
                    const timeToCall = Math.max(0, 16 - (currTime - lastTime))
                    const id = window.setTimeout(() => raf(currTime + timeToCall), timeToCall)
                    lastTime = currTime + timeToCall
                    return id
                }
            }

            if (!window.cancelAnimationFrame) {
                window.cancelAnimationFrame = (id) => {
                    window.clearTimeout(id)
                }
            }
        }())
    },

    arrayIndexOf () {
        // Restore the Array.indexOf on Classic env
        if (dataLayer.isClassic) {
            /* eslint-disable no-extend-native */
            Array.prototype.indexOf = function (a, b) {
                for (var c = b || 0; c < this.length; c++) {
                    if (this[c] === a) {
                        return c
                    }
                }
                return -1
            }
        }
    }

}
